import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SupplierInformationDto } from "../../../autogen/bff-api";
import { TipTap } from "../../input/TipTap/TipTap";
import { AttachmentList } from "./AttachmentList";
import { formatDateTime, personName } from "./communicationUtils";

export const AnnouncementCard = ({
  eventId,
  announcement,
}: {
  // Optional: absent when there is no originating event to scope attachment downloads to (contract-origin view).
  eventId?: string;
  announcement: SupplierInformationDto;
}) => {
  const { t } = useTranslation();
  return (
    <Box borderWidth="1px" borderColor="smBorder" rounded="lg" overflow="hidden" bg="smBackground">
      <Box px="4" py="3" borderBottomWidth="1px" borderColor="smBorder">
        <Text fontSize="md" fontWeight="semibold" color="smText">
          {announcement.title}
        </Text>
      </Box>

      {announcement.question ? (
        <>
          <Box px="4" py="3">
            <Text fontSize="sm" fontWeight="semibold" color="smText" mb="1">
              {t("Question")}
            </Text>
            <TipTap content={announcement.question} editable={false} maxHeight="96" />
          </Box>
          <Box px="4" py="4" borderTopWidth="1px" borderColor="smBorder" bg="smPrimarySofter">
            <Text fontSize="sm" fontWeight="semibold" color="smChipTealFg" mb="1">
              {t("Answer")}
            </Text>
            <TipTap content={announcement.content} editable={false} maxHeight="96" />
          </Box>
        </>
      ) : (
        <Box px="4" py="3">
          <TipTap content={announcement.content} editable={false} maxHeight="96" />
        </Box>
      )}

      <Box px="4" pt="0" pb="2">
        <AttachmentList eventId={eventId} attachments={announcement.attachments} />
      </Box>

      <Box px="4" py="3" borderTopWidth="1px" borderColor="smBorder">
        <Text fontSize="xs" color="smMuted">
          {personName(announcement.createdBy)} · {formatDateTime(announcement.createdAt)}
        </Text>
      </Box>
    </Box>
  );
};
